<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
import md5 from 'js-md5'
import route from './router'
import { $postAxios } from '@/api/http.js'
export default {
  name: 'App',
  data() {
    return {
    }
  }, 
  mounted() {
    // 61.11.175.255
    document.getElementById('app').style.display = 'block';
    switch (performance.navigation.type) {
      case 0: 
        axios.get('https://api64.ipify.org?format=json').then((respones) => {
          $postAxios('other/util/ipSearch', {
            ip: respones.data.ip
          }).then((res) => {
            document.getElementById('appLoading').style.display = 'none';
            var cid = res.data.data.country_id
            sessionStorage.setItem("CID", cid)
            sessionStorage.setItem("init", true)
            if (cid == 'CN') {
              if (this._isMobile()) {
                // 跳转至手机端路由
                this.$router.replace("/mobile-home").catch(err => {});
              } else {
                // 跳转至 pc 端路由
                this.$router.replace("/pc-home").catch(err => {});
              }
            } else {
              this.$router.replace("/jpn-home").catch(err => {});
            }
          })
        });
      case 1:
        document.getElementById('appLoading').style.display = 'none';
    }
  },
  methods: {
    
    // 判断是否是手机端，如果是，返回true
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue